import React from 'react'
import { makeStyles, Box, Button, Typography, Grid } from '@material-ui/core'
import { Link } from 'react-router-dom'
import Oculto from './Oculto'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'

//Presenta un sintoma grave (dificultad para respirar)

const estilos = makeStyles((theme) => ({
  botonPersonalizado: {
    background: 'linear-gradient(45deg, #018786 30%, #018786 90%)',
    border: 0,
    borderRadius: 100,
    color: 'white',
    height: 48,
    padding: '5px 20px',
    fontSize: 20,
    fontWeight: 400,
    width: 140,
    marginBottom: 50,
  },
}))

const ResultadosDos = () => {
  const classes = estilos()

  return (
    <Grid
      container
      direction="column"
      justify="center"
      alignItems="center"
      height="100%"
    >
      <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
        <Box ml={4} mb={4}>
          <Typography variant="h4">Resultados</Typography>
          <Typography variant="body2" color="initial">
            Usted presenta un sintoma grave (dificultad para respirar). Por lo
            que debe llamar al número local de emergencias (911) y acudir
            urgentemente a su centro de salud más cercano.
          </Typography>
        </Box>
      </Grid>

      <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
        <Box ml={4} mb={6} alignItems="left">
          <Typography variant="h4">Tratamiento</Typography>
          <Typography variant="body3" color="initial"></Typography>
        </Box>
      </Grid>

      <List>
        <ListItem>
          <ListItemIcon>
            <ErrorOutlineIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary="Acudir al centro de salud más cercano" />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <ErrorOutlineIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary="Usar mascarilla" />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <ErrorOutlineIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary="Mantener distanciamiento social (mínimo 1 metro)" />
        </ListItem>
      </List>

      <Grid item>
        <Box mt={4}>
          <Link to="/" className="navbarLinks">
            <Button
              size="large"
              className={classes.botonPersonalizado}
              disableElevation
              style={{ marginLeft: '20px' }}
            >
              TERMINAR
            </Button>
          </Link>
        </Box>
      </Grid>
    </Grid>
  )
}

export default ResultadosDos
